import React, { useState } from "react";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Form Submitted!");
    };

    return (
        <div className="container py-5">
            {/* Page Heading */}
            <div className="text-center mb-5">
                <h2 className="fw-bold">Contact Us</h2>
                <p className="text-muted">
                    We're here to help! Reach out to us using the form below or via our contact details.
                </p>
            </div>

            {/* Row 1: Form + Contact Details */}
            <div className="row g-4">
                {/* Contact Form */}
                <div className="col-lg-6">
                    <div className="card p-4 shadow-sm border-0">
                        <h5 className="fw-bold mb-3">Send Us a Message</h5>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-primary w-100 py-2">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="col-lg-6">
                    <div className="card p-4 shadow-sm border-0">
                        <h5 className="fw-bold mb-3">Contact Information</h5>

                        <p className="mb-2"><strong>📍 Address:</strong></p>
                        <p className="text-muted">
                            Nepalgunj Banke
                            Bheri, Lumbini Province, Nepal
                        </p>

                        <p className="mb-2"><strong>📞 Phone:</strong></p>
                        <p className="text-muted">
                            +977-9848427993
                        </p>

                        <p className="mb-2"><strong>📧 Email:</strong></p>
                        <p className="text-muted">
                            support@dialnepal.com.np
                        </p>

                        <p className="mb-2"><strong>🕒 Working Hours:</strong></p>
                        <p className="text-muted">
                            Mon – Fri : 9:00 AM – 6:00 PM
                        </p>
                    </div>
                </div>
            </div>

            {/* Row 2: Map */}
            <div className="row mt-5">
                <div className="col-12">
                    <div className="card shadow-sm border-0">
                        <iframe
                            title="map"
                            src="https://maps.google.com/maps?q=Kathmandu&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="350"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ContactUs;
